"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TutorDeckConsumer = exports.useTutorDeck = exports.ALL_STUDENTS = void 0;
var react_1 = __importStar(require("react"));
var helpers_1 = require("../../helpers");
var FirebaseProvider_1 = require("../FirebaseProvider");
var UserProvider_1 = require("../UserProvider");
var hooks_1 = require("../../hooks");
exports.ALL_STUDENTS = 'ALL_STUDENTS';
function reducer(state, action) {
    var _a, _b;
    switch (action.type) {
        case 'LOAD_STUDENT_DECK':
            return __assign(__assign({}, state), { studentDecks: __assign(__assign({}, state.studentDecks), (_a = {}, _a[action.deck.id] = action.deck, _a)) });
        case 'LOAD_STUDENT_NOTES':
            return __assign(__assign({}, state), { studentNotes: __assign(__assign({}, state.studentNotes), (_b = {}, _b[action.student] = action.notes, _b)) });
        case 'SET_SELECTED_STUDENT':
            return __assign(__assign({}, state), { selectedStudent: action.student });
        default:
            throw new Error();
    }
}
var _a = __read(helpers_1.createContext(), 3), hook = _a[0], Provider = _a[1], Consumer = _a[2];
var TutorDeckProvider = function (_a) {
    var children = _a.children, deck = _a.deck;
    var api = hooks_1.useDeckApi(deck);
    var user = UserProvider_1.useUser();
    var db = FirebaseProvider_1.useFirebase().db;
    var _b = __read(react_1.useReducer(reducer, {
        studentDecks: {},
        studentNotes: {},
        selectedStudent: exports.ALL_STUDENTS,
    }), 2), state = _b[0], dispatch = _b[1];
    var selectedStudent = state.selectedStudent;
    var activeUserId = selectedStudent === exports.ALL_STUDENTS ? user.id : selectedStudent.id;
    var students = deck.students || [];
    react_1.useEffect(function () {
        var subscriptionListeners = [];
        students.forEach(function (student) {
            subscriptionListeners.push(db
                .collection('users')
                .doc(student.id)
                .collection('decks')
                .doc(student.deck)
                .onSnapshot(function (snapshot) {
                if (snapshot.exists) {
                    dispatch({
                        type: 'LOAD_STUDENT_DECK',
                        deck: helpers_1.deserializeDeckDocument(snapshot.data(), student.deck, student.id),
                    });
                }
            }));
            subscriptionListeners.push(db
                .collection('notes')
                .where('deck', '==', student.deck)
                .onSnapshot(function (snapshot) {
                var notes = {};
                snapshot.forEach(function (doc) {
                    notes[doc.id] = __assign(__assign({}, doc.data()), { id: doc.id, createdAt: doc.data().createdAt.toDate() });
                });
                dispatch({
                    type: 'LOAD_STUDENT_NOTES',
                    student: student.id,
                    notes: notes,
                });
            }));
        });
        return function () {
            subscriptionListeners.forEach(function (unsubscribe) {
                unsubscribe();
            });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deck.id, deck.students]);
    var setSelectedStudent = react_1.useCallback(function (student) {
        dispatch({ type: 'SET_SELECTED_STUDENT', student: student });
    }, []);
    var studentCount = deck.students ? deck.students.length : 0;
    var allCards = deck.cards.map(function (card) {
        var cardData = __assign(__assign({}, card), { 'not-started': studentCount, 'needs-work': 0, 'in-progress': 0, mastered: 0, proficiency: 0 });
        return cardData;
    });
    var allCategories = __spread(deck.categories);
    var allSubcategories = __spread(deck.subcategories);
    Object.keys(state.studentDecks).forEach(function (deckId) {
        var studentDeck = state.studentDecks[deckId];
        studentDeck.categories.forEach(function (category) {
            if (!allCategories.includes(category)) {
                allCategories.push(category);
            }
        });
        studentDeck.subcategories.forEach(function (subcategory) {
            if (!allSubcategories.includes(subcategory)) {
                allSubcategories.push(subcategory);
            }
        });
        studentDeck.cards.forEach(function (card) {
            var _a;
            var cardProficiency = helpers_1.getProficiencyKey(card);
            var index = allCards.findIndex(function (_a) {
                var id = _a.id;
                return id === card.id;
            });
            if (index === -1 || !allCards[index].question) {
                var cardData = __assign(__assign({}, card), (_a = { 'not-started': 0, 'in-progress': 0, 'needs-work': 0, mastered: 0 }, _a[cardProficiency] = 1, _a));
                delete cardData.starred;
                var tutorCard = allCards[index] || {};
                cardData = __assign(__assign({}, cardData), tutorCard);
                if (index === -1) {
                    allCards.push(cardData);
                }
                else {
                    allCards[index] = cardData;
                }
            }
            else {
                allCards[index]['not-started'] -= 1;
                allCards[index][cardProficiency] += 1;
                allCards[index].proficiency +=
                    (card.proficiency || 0) / (studentCount || 1);
            }
        });
    });
    var activeDeck = __assign(__assign({}, deck), { cards: allCards, categories: allCategories, subcategories: allSubcategories });
    if (state.selectedStudent !== exports.ALL_STUDENTS) {
        var studentDeck = state.studentDecks[state.selectedStudent.deck];
        var studentNotes_1 = state.studentNotes[state.selectedStudent.id] || [];
        if (studentDeck) {
            activeDeck = __assign(__assign({}, studentDeck), { name: deck.name, students: deck.students, roles: deck.roles, notes: studentDeck.notes.map(function (note) {
                    if (studentNotes_1[note.id]) {
                        return __assign(__assign({}, note), studentNotes_1[note.id]);
                    }
                    var parentDeckNote = deck.notes.find(function (deckNote) { return deckNote.id === note.id; });
                    if (parentDeckNote) {
                        return __assign(__assign({}, note), parentDeckNote);
                    }
                    return note;
                }) });
        }
    }
    var addCard = react_1.useCallback(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var cardId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.addCard(data, activeUserId, activeDeck.id)];
                case 1:
                    cardId = _a.sent();
                    // If tutor added the card to the master deck
                    // add it to all student decks
                    if (activeUserId === user.id) {
                        students.forEach(function (student) {
                            // Add card to student's deck
                            api.addCardToDeck(cardId, data, student.id, student.deck);
                            // Add cheat-sheet to student's deck
                            api.addCardSummaryToCheatSheet(cardId, data, student.id, student.deck);
                        });
                    }
                    return [2 /*return*/, cardId];
            }
        });
    }); }, [activeDeck.id, activeUserId, api, students, user.id]);
    var addNote = react_1.useCallback(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var noteId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.addNote(data, activeUserId, activeDeck.id)];
                case 1:
                    noteId = _a.sent();
                    // If tutor added the note to the master deck
                    // add it to all student decks
                    if (activeUserId === user.id) {
                        students.forEach(function (student) {
                            // Add note to student's deck
                            api.addNote(__assign(__assign({}, data), { parent: noteId }), student.id, student.deck);
                        });
                    }
                    return [2 /*return*/, noteId];
            }
        });
    }); }, [activeDeck.id, activeUserId, api, students, user.id]);
    var updateNote = react_1.useCallback(function (note, data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            api.updateNote(note, data, activeUserId, activeDeck.id);
            // If tutor added the card to the master deck
            // add it to all student decks
            if (activeUserId === user.id) {
                console.log('updating student notes');
                students.forEach(function (student) {
                    // Add card to student's deck
                    console.log('state.studentNotes', state.studentNotes);
                    console.log('state.studentNotes[student.id]', state.studentNotes[student.id]);
                    if (state.studentNotes[student.id]) {
                        var studentNote = Object.values(state.studentNotes[student.id]).find(function (sNote) { return sNote.parent === note.id; });
                        console.log('studentNote', studentNote);
                        console.log('studentNote', studentNote);
                        if (studentNote) {
                            api.updateNote(__assign(__assign({}, note), { id: studentNote.id }), data, student.id, student.deck);
                        }
                    }
                });
            }
            return [2 /*return*/];
        });
    }); }, [activeDeck.id, activeUserId, api, students, user.id]);
    return (react_1.default.createElement(Provider, { value: __assign(__assign(__assign({}, deck), state), { students: deck.students || [], addCard: addCard,
            addNote: addNote,
            updateNote: updateNote,
            activeDeck: activeDeck, cards: activeDeck.cards, setSelectedStudent: setSelectedStudent }) }, children));
};
exports.useTutorDeck = hook;
exports.TutorDeckConsumer = Consumer;
exports.default = TutorDeckProvider;
//# sourceMappingURL=TutorDeckProvider.js.map